/**
 * Normaliza string para slug (igual ao backend).
 * @param {string} value
 * @returns {string}
 */
export function toSlug(value) {
  if (value == null || typeof value !== 'string') return '';
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}
